module.exports = __webpack_public_path__ + "img/plan3.79f7c6f.webp";